/**
 * Chinese copy. Ported verbatim from wechat/src/i18n/zh.js.
 *
 * Shared so a wording change lands in both apps at once. If a key exists
 * here it must exist in the other language file too — see i18n/index.ts,
 * which fails loudly on a missing key rather than rendering the key name.
 */
export const zh = {
  'ev.pullToRefresh': '下拉刷新',
  'ev.releaseToRefresh': '释放即可刷新',
  'ev.linkCopied': '链接已复制',
  'ev.shareHint': '点击右上角 ··· 分享这场餐桌',
  'ev.notFound': '这场餐桌已不可用。',
  'sms.kicker': '免费加入',
  'sms.title': '你的手机号',
  'sms.sub': '我们会发送 6 位验证码，无需记住密码。',
  'sms.phonePlaceholder': '手机号',
  'sms.codePlaceholder': '验证码',
  'sms.sendCode': '获取验证码',
  'sms.verify': '继续',
  'sms.codeSent': '验证码已发送',
  'sms.sendFailed': '验证码发送失败，请重试。',
  'sms.wrongCode': '验证码不正确。',
  'sms.invalidPhone': '请输入有效的手机号',
  'sms.enterCode': '请输入收到的验证码',
  'sms.legal': '继续即表示同意我们的条款与隐私政策。',

  'brand.suffix': '社交饭局',

  'nav.apply': '申请',
  'nav.dining': '社交饭局',
  'nav.six': '六人局',
  'nav.profile': '我的',

  'common.loading': '加载中…',
  'common.optional': '选填',
  'common.back': '返回',
  'common.empty': '这里还没有内容。',
  'common.continue': '继续',
  'common.retry': '重试',
  'common.yes': '是',
  'common.no': '否',

  'choose.kicker': '入座之前',
  'choose.title': '你为什么而来？',
  'choose.sub': '选一个最贴近你的。它决定我们问你的几个问题，也决定谁坐在你身边。',
  'choose.foot': '之后可以随时更改——很多人为一件事而来，却因另一件事留下。',

  'apply.reviewed': '真人逐一审核 · 多数人 48 小时内收到回复',
  'apply.submit': '提交申请',
  'apply.save': '保存修改',
  'apply.back': '← 换一个理由',
  'apply.editnote': '你已提交申请——在下方修改任意答案并保存，排队位置不变。',
  'apply.progress': '完成度 {n}%',
  'apply.fillRequired': '请先填写必填的问题。',
  'apply.saved': '已保存',
  'apply.submitted': '申请已提交',
  'apply.completeFirst': '请先提交申请以解锁此功能。',
  'apply.reserveNotice': '请先完成注册，再预订这一桌的座位。',

  'onboarding.stageCore': '你的资料',
  'onboarding.stageMatching': '更好地匹配',
  'onboarding.progressStart': '选择后开始',
  'onboarding.progressComplete': '核心资料已完成',
  'onboarding.progressOne': '还剩 1 个页面',
  'onboarding.progressMany': '还剩 {n} 个页面',
  'onboarding.motivationTitle': '你为什么而来？',
  'onboarding.motivationSub': '选择今天最符合你的一个。它会决定我们问你的问题，也会影响我们为你安排的同桌。',
  'onboarding.coreDone': '你的资料已准备好',
  'onboarding.matchTitle': '想让我们更好地为你匹配吗？',
  'onboarding.matchSub': '再回答几个问题，帮助我们为你找到更合拍的人和餐桌。',
  'onboarding.matchNow': '现在完善匹配',
  'onboarding.matchLater': '稍后再填',
  'onboarding.finish': '完成我的资料',
  'onboarding.skipHint': '可以留空并继续。',
  'onboarding.answerRequired': '请选择或填写答案后继续。',
  'onboarding.saveFailed': '暂时无法保存，请重试。',
  'onboarding.loadFailed': '暂时无法加载资料页面。',
  'onboarding.loadFailedSub': '请检查网络后重试。',
  'onboarding.done': '资料已完成',

  'restaurantFinder.pickFromList': '请从下方列表中选择。',
  'restaurantFinder.searchPlaceholder': '搜索餐厅、商圈、地址、口味…',
  'restaurantFinder.loading': '正在加载餐厅…',
  'restaurantFinder.defaultResults': '先显示 20 家餐厅',
  'restaurantFinder.results': '最接近的结果',
  'restaurantFinder.empty': '没有找到餐厅。',
  'restaurantFinder.error': '暂时无法加载餐厅，请重试。',
  'restaurantFinder.rating': '评分',

  'gate.kicker': '开始前的一步',
  'gate.title': '关联你的微信',
  'gate.sub': 'Top Chopsticks 会把你安排到真实的餐桌上，因此进入前需要先关联你的微信账号。',
  'gate.contract': '查看隐私保护指引',
  'gate.agree': '同意并继续',
  'gate.decline': '暂不',
  'gate.declined': '需要关联微信才能使用本小程序。',
  'gate.step2': '就快好了',
  'gate.authFailed': '微信登录失败',
  'gate.authFailedSub': '使用 Top Chopsticks 前需要先登录。分享的活动页面仍可直接查看。',

  'wxp.title': '使用你的微信资料？',
  'wxp.sub': '点击头像可使用你的微信头像，点击名字栏可填入你的微信昵称。完全可选——不填也不影响使用。',
  'wxp.titleReq': '你的头像和昵称',
  'wxp.subReq': '点击输入框选择你的微信昵称。头像可选，不上传我们会为你分配一个。',
  'wxp.continue': '继续',
  'wxp.needName': '请填写你的名字',
  'wxp.needBoth': '请填写头像和昵称。',
  'wxp.avatarFailed': '昵称已保存——头像上传失败。',
  'wxp.avatarFailedTitle': '头像上传失败',
  'wxp.avatarFailedDetail': '昵称已经保存，但头像没有上传成功。请到「我的」页面再试一次。',
  'wxp.avatarHint': '点击选择头像',
  'wxp.namePlaceholder': '你的名字',
  'wxp.save': '就用这个',
  'wxp.skip': '暂不',
  'wxp.saved': '已更新你的资料',
  'wxp.failed': '保存失败，可稍后在「我的」页面再试。',
  'wxp.failedTitle': '资料更新失败',
  'wxp.failedDetail': '暂时无法保存你的资料，请稍后再试。',

  'ev.curated': '官方精选',
  'ev.community': '社区自组',
  'ev.info': '目前所有人都能看到全部活动。等社区壮大后，你就能按来意筛选。',
  'ev.commInfo': '社区餐桌由会员发起，而非官方。初期我们全部展示——之后可按来意、区域等筛选。',
  'ev.invited': '为你而设',
  'ev.more': '更多精选餐桌',
  'ev.details': '查看详情',
  'ev.aboutTitle': '关于这一桌',
  'ev.seatConfirmed': '你的座位已确认。',
  'ev.hide': '收起详情',
  'ev.reserve': '预订餐位',
  'ev.join': '报名',
  'ev.address': '地址',
  'ev.addressCopied': '地址已复制',
  'ev.copyFailed': '复制失败',
  'ev.languages': '桌上使用的语言',
  'ev.qrTitle': '加入群聊',
  'ev.qrHint': '扫码加入本桌的微信群。',
  'ev.reserveNoPay': '预订座位',
  'ev.payLaterNote': '现在无需付款——到场后与我们结算。',
  'ev.reserved': '预订成功——到时见',
  'ev.bookedLabel': '已预订 ✓',
  'ev.cancelReservation': '取消我的预订',
  'ev.cancelConfirmTitle': '取消座位？',
  'ev.cancelConfirm': '你的座位将释放给其他人。如果还有空位，之后仍可再次预订。',
  'ev.cancelConfirmYes': '确定',
  'ev.cancelConfirmNo': '保留',
  'ev.cancelled': '预订已取消',
  'ev.cancelFailed': '取消失败，请重试。',
  'ev.share': '分享',
  'ev.joined': '报名成功——座位已锁定',
  'ev.joinFailed': '报名失败，请再试一次。',
  'ev.free': '免费',
  'ev.seat': '餐位（全包）',
  'ev.seatsRemaining': '个席位剩余',
  'ev.people': '人数',
  'ev.curatedBy': '策划人',
  'ev.format': '形式',
  'ev.menuPreview': '菜单预览',
  'ev.spark': '今晚的破冰题',
  'ev.fullMenu': '完整菜单——已翻译并按你的忌口筛选——开席前 24 小时揭晓。',
  'ev.swipePhotos': '滑动查看更多照片 ›',
  'ev.vipNote': '🔒 六人局——我们亲手匹配的 VIP 餐桌——从不在此列出。与我们吃过饭后，会在「六人局」中出现。',
  'ev.finishedLabel': '活动已结束',
  'ev.attendedLabel': '你已参加',
  'guest.incompleteTitle': '就差一步',
  'guest.incompleteSub': '你已用微信登录，回答几个问题即可订座并参与匹配。',
  'guest.ctaFinish': '完成注册',
  'guest.cta': '免费加入',
  'guest.eventsTitle': '免费加入即可订座',
  'guest.eventsSub': '简单介绍一下你自己，我们会为你匹配合适的餐桌。',
  'guest.sixTitle': '为你挑选的餐桌',
  'guest.sixSub': '回答几个问题，我们的匹配会让你遇到真正聊得来的人。',
  'guest.profileTitle': '这里还是空的',
  'guest.profileSub': '免费加入即可保存资料、预订座位并获得匹配。',
  'guest.reserveLocked': '免费加入即可订座',
  'ev.seePast': '查看往期活动',
  'ev.hidePast': '收起往期活动',
  'ev.hostCta': '想自己办一场？点「组织你的餐桌」。',
  'ev.curatedHeading': '我们的精选',
  'ev.communityHeading': '社区餐桌',
  'ev.emptyCurated': '暂无精选餐桌——请稍后再来。',
  'ev.emptyCommunity': '暂无社区餐桌。',
  'ev.empty': '暂无活动——请稍后再来。',

  'fab.label': '组织你的餐桌',
  'org.kicker': '与我们合办',
  'org.title': '组织你的餐桌',
  'org.sub': '想办一场饭局、品鉴或主题夜？我们帮你把位子填满。现在，先在微信上跟我们打个招呼，剩下的交给我们。',
  'org.can': '你可以办什么',
  'org.1t': '与我们共同策划的餐桌',
  'org.1d': '我们共同设计、筛选嘉宾、安排座位——你出点子。',
  'org.2t': '自助式社区活动',
  'org.2d': '你的饭局，你说了算。发布出来，我们帮它找到对的人。',
  'org.3t': '线上之夜',
  'org.3d': '食谱交换、云做饭、视频品鉴。（稍后推出）',
  'org.scan': '扫码加我们微信',
  'org.got': '知道了',
  'orgFlow.title': '组织你的餐桌',
  'orgFlow.requiredPrefix': '必填：',
  'orgFlow.priceRequired': '选择到店支付时需要填写每人价格。',
  'orgFlow.typeCommunity': '社区活动',
  'orgFlow.type1to1': '一对一',
  'orgFlow.typeKicker': '第一步',
  'orgFlow.typeTitle': '你想组织什么？',
  'orgFlow.typeSub': '先选择形式，接下来只问几个关键问题。',
  'orgFlow.stageType': '活动类型',
  'orgFlow.panelPrompt': '告诉我们有用的信息。先大概写也可以。',
  'orgFlow.step': '第 {n}/{total} 步',
  'orgFlow.panelsLeft': '还剩 {n} 个',
  'orgFlow.save': '保存',
  'orgFlow.saved': '草稿已保存',
  'orgFlow.cancel': '取消',
  'orgFlow.discardTitle': '放弃这个草稿？',
  'orgFlow.discardBody': '未保存的修改会丢失。如果想稍后继续，请先保存。',
  'orgFlow.keepEditing': '继续编辑',
  'orgFlow.discard': '放弃',
  'orgFlow.pickType': '请先选择活动类型。',
  'orgFlow.submit': '提交',
  'orgFlow.submitCommunity': '提交活动',
  'orgFlow.submitOneToOne': '提交一对一餐桌',
  'orgFlow.updateCommunity': '更新活动',
  'orgFlow.updateOneToOne': '更新一对一餐桌',
  'orgFlow.slotDuplicate': '该时间已在列表中。',
  'orgFlow.draftKept': '草稿已保存。',
  'orgFlow.pendingTag': '等待审核',
  'orgFlow.slotsHint': '请至少添加一个时间选项。',
  'orgFlow.photoAdd': '选择照片',
  'orgFlow.photoReplace': '更换照片',
  'orgFlow.photoHint': '选填 · JPG 或 PNG · 最大 5 MB',
  'orgFlow.photoTooBig': '图片超过 5 MB。',
  'orgFlow.photoFailed': '上传失败，请重试。',
  'orgFlow.pendingHint': '我们的团队会在 24-48 小时内审核。',
  'orgFlow.submitFailed': '暂时无法提交，请重试。',
  'orgFlow.loadFailed': '暂时无法加载组织活动页面。',
  'orgFlow.loadFailedSub': '请检查网络后重试。',
  'orgFlow.doneTitle': '已提交审核',
  'orgFlow.doneSub': '我们的团队会在 24-48 小时内审核。结果会在这里通知你。',
  'orgFlow.updatedTitle': '你的活动想法已更新',
  'orgFlow.updatedSub': '我们的团队会在 24-48 小时内审核你的修改。',
  'orgFlow.backToEvents': '返回活动',
  'orgFlow.myRequests': '你的组织申请',
  'orgFlow.waitingApproval': '等待审核',
  'orgFlow.editRequest': '修改',
  'orgFlow.untitledRequest': '未命名餐桌想法',
  'orgFlow.people': '{n} 人',

  'six.badge': '仅限邀请',
  'six.exTitle': '六人局 — 为你挑选的餐桌',
  'six.exSub': '我们的 VIP 餐桌只坐六人，全部由我们亲手匹配。从不公开列出，也不会出现在「社交饭局」中。',
  'six.exHow': '我们如何匹配你',
  'six.s1t': '先来参加活动',
  'six.s1p': '来几场精选饭局，让我们看到你与一桌人的相处。',
  'six.s2t': '我们亲自审核',
  'six.s2p': '团队会看你的资料、忌口与兴趣的契合度，以及你和谁吃得来。没有算法替你决定座位。',
  'six.s3t': '你收到邀请',
  'six.s3p': '当我们确信这六人会合拍时，便发出私密邀请。你事先只会知道日期。',
  'six.exFoot': '与我们吃过第一顿饭后即可解锁。先从「社交饭局」开始。',
  'six.exCta': '查看社交饭局',
  'six.inTitle': '为你挑选的餐桌',
  'six.inSub': '根据你与我们的几次饭局，我们亲手为你匹配了五位你会喜欢的人。这些餐桌从不公开。再信我们一次。',
  'six.inWhereImg': '你可能用餐的地方',
  'six.inWhen': '时间',
  'six.inWhere': '地点',
  'six.inWho': '同桌',
  'six.inMenu': '菜单',
  'six.inAccept': '接受邀请',
  'six.inSeats': '席仅余（共6席）',
  'six.inLater': '下次再说',
  'six.inExpires': '邀请将在以下时间后失效',

  'pay.kicker': '确认餐位',
  'pay.date': '日期',
  'pay.seat': '餐位',
  'pay.includes': '包含',
  'pay.includesv': '全套菜单 · 服务',
  'pay.cancel': '取消政策',
  'pay.cancelv': '提前72h免费 · 24h内退50%',
  'pay.warn': '餐位为你量身匹配——一个空位就破坏了整桌。缺席不退款。',
  'pay.pay': '微信支付',
  'pay.paid': '支付成功',
  'pay.back': '返回',

  'profile.member': '会员',
  'profile.myApplication': '我的申请',
  'profile.title': '我的资料',
  'profile.app': '我的申请',
  'profile.herefor': '来意',
  'profile.status': '状态',
  'profile.submitted': '提交时间',
  'profile.completion': '资料完成度',
  'profile.update': '修改我的申请',
  'profile.membership': '会籍',
  'profile.invited': '推荐人',
  'profile.attended': '已参加饭局',
  'profile.meetAgain': '获再约意愿',
  'profile.referrals': '推荐名额',
  'profile.gift': '可赠 1 席',
  'profile.high': '高',
  'profile.lang': '语言',
  'profile.session': '账户',
  'profile.refreshWechatLogin': '刷新微信登录',
  'profile.wechatLoginRefreshed': '微信登录已刷新',
  'profile.wechatLoginRefreshFailedTitle': '刷新微信登录失败',
  'profile.wechatLoginRefreshFailedDetail': '请稍后再试。',
  'profile.logout': '退出登录',
  'profile.login': '微信登录',
  'profile.loginHint': '你已退出。登录以同步资料与匹配。',
  'profile.loggedOut': '已退出',
  'profile.devMode': 'DEV',
  'profile.buildVersion': '小程序版本',
  'profile.forceSignOut': '强制退出（清除会话）',
  'profile.sessionCleared': '会话已清除',
  'profile.seeEventsAsPublic': '以访客身份查看活动',
  'profile.seeEventsAsSelf': '以本人身份查看活动',
  'profile.viewPublic': '访客',
  'profile.viewSelf': '本人',
  'profile.seeProfilePanel': '查看资料页面',

  'intent.gastronomy': '美食',
  'intent.professional_networking': '社交人脉',
  'intent.local_friendships': '本地朋友',

  'tone.food': '为美食',
  'tone.network': '值得结识',
  'tone.local': '本地朋友'
} as const
